import React from 'react'
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa'
import { AiOutlineMedium } from 'react-icons/ai';
import './socials.css';

const Socials = ({ classToApply }) => {
    return (
        <div className={classToApply}>
            <a rel="noreferrer" href="https://www.linkedin.com/in/bhuwan-pandey/" target="_blank"><BsLinkedin /></a>
            <a rel="noreferrer" href="https://medium.com/@bp-pandey7" target="_blank"><AiOutlineMedium /></a>
            <a rel="noreferrer" href="https://github.com/bhuwanpandey7" target="_blank"><FaGithub /></a>
        </div>
    );
}

export default Socials;